(() => {
  'use strict';

  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const restoreMarqueeMotion = (root = document) => {
    if (motionQuery.matches) return;

    root.querySelectorAll?.('marquee-component').forEach((marquee) => {
      marquee.removeAttribute('data-disabled');
      const wrapper = marquee.querySelector('.marquee__wrapper');
      window.requestAnimationFrame(() => {
        wrapper?.getAnimations().forEach((animation) => {
          animation.play();
          animation.updatePlaybackRate(1);
        });
      });
    });
  };

  const stopAutomaticMotion = (root = document) => {
    root.querySelectorAll?.('slideshow-component[autoplay]').forEach((slideshow) => {
      if (typeof slideshow.pause === 'function') slideshow.pause();
      slideshow.setAttribute('paused', '');
      slideshow.removeAttribute('autoplay');
    });

    restoreMarqueeMotion(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => stopAutomaticMotion(), {
      once: true,
    });
  } else {
    stopAutomaticMotion();
  }

  window.customElements?.whenDefined('slideshow-component').then(() => {
    stopAutomaticMotion();
  });

  window.customElements?.whenDefined('marquee-component').then(() => {
    restoreMarqueeMotion();
  });

  let marqueeFrame = 0;
  const scheduleMarqueeRestore = () => {
    if (marqueeFrame || motionQuery.matches) return;
    marqueeFrame = window.requestAnimationFrame(() => {
      marqueeFrame = 0;
      restoreMarqueeMotion();
    });
  };

  document.addEventListener(
    'pointerenter',
    (event) => {
      if (
        event.target instanceof Element &&
        event.target.matches('marquee-component')
      ) {
        event.stopImmediatePropagation();
        scheduleMarqueeRestore();
      }
    },
    true,
  );

  // Scrolling does not change marquee state; restore only on component/state changes.

  const mutationTouchesMarquee = (mutation) => {
    if (
      mutation.type === 'attributes' &&
      mutation.target instanceof Element
    ) {
      return mutation.target.matches('marquee-component[data-disabled]');
    }
    return [...mutation.addedNodes].some(
      (node) =>
        node instanceof Element &&
        (node.matches('marquee-component') ||
          node.querySelector('marquee-component')),
    );
  };

  new MutationObserver((mutations) => {
    if (mutations.some(mutationTouchesMarquee)) scheduleMarqueeRestore();
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-disabled'],
    childList: true,
    subtree: true,
  });

  document.addEventListener('shopify:section:load', (event) => {
    stopAutomaticMotion(event.target instanceof Element ? event.target : document);
  });
})();
